package fr.labodoc.healthProfessional.webApp.data.error

sealed class RepositoryError {
  data class DataSource(val cause: DataSourceError): RepositoryError()

  data object NotFound: RepositoryError()
}
